import { MarketCard } from './MarketCard';
import { CardSkeleton } from '../common/Loading';

export function MarketList({ markets, predictions, loading }) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {[...Array(6)].map((_, i) => (
          <CardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (!markets?.length) {
    return (
      <div className="text-center py-12 text-gray-500">
        No markets found
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {markets.map((market) => (
        <MarketCard
          key={market.id}
          market={market}
          prediction={predictions[market.id]}
        />
      ))}
    </div>
  );
}
